'use client';

import { useEffect, useState } from 'react';
import { adManager } from '@/utils/adManager';

export default function AdPerformanceMonitor() {
  const [stats, setStats] = useState(adManager.getAdStats());
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 只在开发环境下显示
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    // 按 Ctrl+Shift+A 显示/隐藏监控面板
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        setIsVisible(!isVisible);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    // 定期更新统计信息
    const interval = setInterval(() => {
      setStats(adManager.getAdStats());
    }, 1000);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearInterval(interval);
    };
  }, [isVisible]);

  if (process.env.NODE_ENV !== 'development' || !isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-90 text-white p-4 rounded-lg shadow-lg z-50 min-w-64">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold">广告性能监控</h3>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-white"
        >
          ✕
        </button>
      </div>
      
      <div className="space-y-2 text-xs">
        <div className="flex justify-between">
          <span>总广告位:</span>
          <span className="font-mono">{stats.total}</span>
        </div>
        <div className="flex justify-between">
          <span>已加载:</span>
          <span className="font-mono text-green-400">{stats.loaded}</span>
        </div>
        <div className="flex justify-between">
          <span>加载中:</span>
          <span className="font-mono text-yellow-400">{stats.loading}</span>
        </div>
        <div className="flex justify-between">
          <span>加载率:</span>
          <span className="font-mono text-blue-400">
            {stats.total > 0 ? Math.round((stats.loaded / stats.total) * 100) : 0}%
          </span>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-600">
        <div className="text-xs text-gray-400">
          <p>按 Ctrl+Shift+A 切换显示</p>
          <p>广告位数量: {stats.total}</p>
        </div>
      </div>
    </div>
  );
} 